// src/components/dialog/DlgDelete.tsx

import { CancelTwoTone, DeleteTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material'
import { ReactNode } from 'react'

import { KARMA_ConfirmDialog } from '@/types/karma/dialog'

import { HStack } from '../HStack'

import { DlgCloseButton } from './DlgCloseButton'

type DlgDeleteProps = KARMA_ConfirmDialog & {
  children: ReactNode
}

export const DlgDelete = ({
  onCancel,
  onConfirm,
  open,
  children,
}: DlgDeleteProps) => {
  const theme = useTheme()
  const bgcolor = theme.palette.secondary.main
  const color = theme.palette.white

  return (
    <Dialog fullWidth={true} open={open} onClose={onCancel}>
      <DialogTitle>
        <HStack>
          <Avatar sx={{ bgcolor, color, mr: 1 }}>
            <DeleteTwoTone />
          </Avatar>
          <Typography>Löschen bestätigen</Typography>
        </HStack>
        <DlgCloseButton onClick={onCancel} />
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Button color={'error'} onClick={onConfirm}>
          <DeleteTwoTone />
          Löschen
        </Button>

        <Button onClick={onCancel}>
          <CancelTwoTone />
          Abbrechen
        </Button>
      </DialogActions>
    </Dialog>
  )
}
